import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { push } from 'connected-react-router';
import {debounce} from '../../helpers/debounce.js';
import {
	Card,
	Button,
	CardTitle,
	Alert,
	Input,
	Modal,
	ModalHeader,
	ModalBody,
	Row,
	Col
} from 'reactstrap';

import {
	getRetailAppsList,
	moveSingleAppToRetail,
	fetchPackages,
	filteringPackages,
	saveNewPackage,
	addAppsToPackage,
	removeAppsFromPackage,
	removePackage,
	getRetailPackageList,
	changePackName
} from '../../actions/retailActions';
import {updateActiveApk, uploadNewApk} from '../../actions/marketActions';
import { closeAlert } from '../../actions/commonsActions';
import { updatePocketAttributes } from '../../actions/attributesActions';
import SinglePackage from '../SinglePackage/SinglePackage';
import CompanyMarketAppList from '../CompanyMarketAppList/CompanyMarketAppList';
import PackagesList from './PackagesList';
import {fetchCompanies} from "../../actions/companyActions";
import {PAGINATION_DEFAULT_LIMIT, USER_ROLES, VIEWS} from '../../helpers/constants';
import {I18n} from '../../I18n/components/companyMarket';

import 'react-table/react-table.css';
import './companyMarket.css';
import MarketControls from './MarketControls';
import UploadModal from './UploadModal';
import MoveModal from "./MoveModal";
import DelPackageModal from "./DelPackageModal";
import RemoveAppModal from "./RemoveAppModal";
import ViewAppModal from "./ViewAppModal";
import ViewAttributesModal from "./ViewAttributesModal";
import PackageManagerModal from "./PackageManagerModal";
import AddPackageModal from "./AddPackageModal";
import {changeUpdatesStatus, fetchNewAlertNotifications} from "../../actions/alertActions";


class CompanyMarket extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentPage: 0,
			prev_filters: [],
			active_filters:[],
			isLoadingApps: false,
			isOkMoveModal: false,
			isOkDelPackageModal: false,
			isOkViewAppModal: false,
			isOkCreatePackageModal: false,
			isOkAttributesPackageModal: false,
			isOkPackageManagerModal: false,
			selectedAppId: null,
			selectedPackageId: null,
			activeView: 'ALL',
			activePackage: null,
			selectedPackage: {},
			activeAppId: null,
			activeApkIds: [],
			activeRetailMarketItemId: null,
			currentPackageName: '',
			checkedAppIds: [],
			isPackageDropdownOpen: false,
			isPackageNameExist: false,
			filteredPackageWord: '',
			isOkMoveAppFromPackageModal: false,
			globalView: VIEWS.PACKAGE_AND_APP,
            uploadModal: false,
            uploadApkName: "Выбор файла",
            uploadApk: null,
            isApkUpload: false,
			uploadMessage: null,
			uploadComment: null,
			appNameFilterWord: '',

            hasUpdates: false,
		};
	}

	componentDidMount() {
		(async () => {
			if (!this.props.company) {
				const res = await this.props.fetchCompanies();
			}
			const getDataFn = this.chooseGetDataMethodByView();
			this.setState({
				isLoadingApps: true
			}, () => {
				getDataFn({
					companyId: this.props.company ? this.props.company.id : null
				}).then(() => {
					this.props.fetchNewAlertNotifications({
						companyId: this.props.company.id,
						page: 0,
						limit: PAGINATION_DEFAULT_LIMIT,
					}).then(() => {
						this.setState({
							isLoadingApps: false,
                            hasUpdates: this.props.newAlertsTotal !== 0
						});
					}).catch(error => {console.log(error)});
				});
			});

		})();
	}

	chooseGetDataMethodByView = activeView => {
		switch (activeView || this.state.activeView) {
		 	case VIEWS.ALL: {
				return this.props.getRetailAppsList
			}
			case VIEWS.POCKET: {
				return this.props.getRetailPackageList
			}
			default: {
				return this.props.getRetailAppsList
			}
		}
	};

	fetchAppList = (query, getDataFn) => {
		this.setState({
			isLoadingApps: true
		});
		return getDataFn(query).then(res => {
			this.setState({
				isLoadingApps: false,
			});
			return res
		});
	};

	fetchPaginatedData = async currentPage => {
		if (!this.state.active_filters) {
			this.setState({
				currentPage
			});
			await this.fetchAppList({
				companyId: this.props.company.id,
				page: currentPage,
				packageId: this.state.activePackage
			}, this.chooseGetDataMethodByView(this.state.activeView))
		} else {
			if (isEqual(sortBy(this.state.active_filters), sortBy(this.state.prev_filters))) {
				await this.fetchAppList({
					companyId: this.props.company.id,
					filter: this.state.active_filters.join(','),
					page: currentPage,
					packageId: this.state.activePackage
				}, this.chooseGetDataMethodByView(this.state.activeView));

				await this.setState({
					currentPage
				});
			} else {
				await this.fetchAppList({
					companyId: this.props.company.id,
					filter: this.state.active_filters.join(','),
					packageId: this.state.activePackage
				}, this.chooseGetDataMethodByView(this.state.activeView));
				await this.setState(state => ({
					currentPage: 0,
					rev_filters: state.active_filters
				}));
			}
		}
	};

	setCurrentPage = currentPage => {
		this.setState({
			currentPage
		});
		this.fetchPaginatedData(currentPage)
	};

	removeAppFromRetail = () => {
		this.props.moveSingleAppToRetail(this.state.selectedAppId).then(res => {
			if (res) {
				this.fetchPaginatedData(this.state.currentPage);
				this.isOkMoveModalToggle(null);
			}
		});
	};

	updatePocketAttributesList = async attributes => {
		if (this.state.currentPackageName !== this.state.selectedPackage.name) {
			const pack = Object.assign({}, this.state.selectedPackage)
			pack.name = this.state.currentPackageName;
			await this.props.changePackName(pack);
			await this.props.getPackagesList();
		}
		if (attributes) {
			await this.props.updatePocketAttributes(attributes);
			await this.props.getPackagesList();
		}
		if (this.state.currentPackageName !== this.state.selectedPackage.name || attributes) {
			this.setState({
				isOkAttributesPackageModal: !this.state.isOkAttributesPackageModal,
				selectedPackage: {}
			});
			setTimeout(() => {
				this.props.closeAlert();
			}, 3000);
		}
	};

	isOkAttributesPackageModalToggle = bundle => {
		return event => {
			event.stopPropagation();
			if (bundle) {
				this.setState({
					isOkAttributesPackageModal: !this.state.isOkAttributesPackageModal,
					selectedPackage: bundle,
					currentPackageName: bundle.name
				})
			} else {
				this.setState({
					isOkAttributesPackageModal: !this.state.isOkAttributesPackageModal,
					selectedPackage: {}
				})
			}
		}
	};

	attributesPackageModalToggle = () => {
		this.setState({
			isOkAttributesPackageModal: !this.state.isOkAttributesPackageModal
		});
	};

	isOkCreatePackageModalToggle = () => {
		this.setState({
			isOkCreatePackageModal: !this.state.isOkCreatePackageModal
		});
	};

	isOkPackageManagerToggle = () => {
		this.setState({
			isOkPackageManagerModal: !this.state.isOkPackageManagerModal
		});
	};

	onChangePackageName = event => {
		const name = event.target.value;
		this.setState({
			currentPackageName: name
		}, () => {
			this.checkIsPackageNameExist(name);
		});
	};

	isOkMoveModalToggle = appId => {
		this.setState({
			isOkMoveModal: !this.state.isOkMoveModal,
			selectedAppId: appId
		});
	};

	isOkDelPackageModalToggle = packageId => {
		this.setState({
			isOkDelPackageModal: !this.state.isOkDelPackageModal,
			selectedPackageId: packageId
		});
	};

	isOkMoveAppFromPackageModalToggle = appId => {
		this.setState({
			isOkMoveAppFromPackageModal: !this.state.isOkMoveAppFromPackageModal,
			selectedAppId: appId
		});
	};

	isOkViewAppModalToggle = (apps, selectedAppId) => {
		if (apps && selectedAppId) {
			const id = selectedAppId;
			const activeApk = apps.filter(app => app.mobileAppId === id);
			this.setState(state => ({
				activeAppId : id,
				activeApkIds : activeApk[0].checkedApkIds || [],
				activeRetailMarketItemId: activeApk[0].retailMarketItemId || null,
				isOkViewAppModal: !state.isOkViewAppModal
			}));
		} else {
			this.setState(state => ({
				activeAppId: null,
				activeApkIds: [],
				activeRetailMarketItemId: null,
				isOkViewAppModal: !state.isOkViewAppModal
			}));
		}
	};

	showCurentPackage = async (packageId) => {
		const selectedPackage = this.props.packages.filter(item => {
			return item.id === packageId
		});
		if (selectedPackage.length) {
			this.setState({
				activeView: VIEWS.POCKET,
				activePackage: `${packageId}`,
			}, () => {
				this.setCurrentPage(0);
			})
		}
	};

	changeStatusCheckedApps = checkedAppId => {
		const { checkedAppIds } = this.state;
		const checkedAppIndex = checkedAppIds.findIndex(item => item === checkedAppId);
		if (checkedAppIndex !== -1) {
			checkedAppIds.splice(checkedAppIndex, 1);
			this.setState({
				checkedAppIds: checkedAppIds
			});
		} else {
			this.setState(state => ({
				checkedAppIds: [...state.checkedAppIds, checkedAppId]
			}));
		}
	};

	clearAllCheckedApps = () => {
		this.setState({
			checkedAppIds: []
		});
		this.fetchPaginatedData(this.state.currentPage)
	};

	addPackage = event => {
		event.preventDefault();
		if (this.state.currentPackageName.length > 1) {
			this.props.saveNewPackage(this.state.currentPackageName, this.props.company.id).then( async (res) => {
				if (res) {
					await this.props.getPackagesList();
					this.setState({
						isOkCreatePackageModal: !this.state.isOkCreatePackageModal,
						currentPackageName: ''
					});
				}
			});
		}
	};

	removeActivePackage = () => {
		this.props.removePackage(this.state.selectedPackageId).then( async (res) => {
			if (res) {
				await this.props.getPackagesList();
				this.isOkDelPackageModalToggle(null);
			}
		});
	};

	togglePackageDropdown = () => {
		this.setState({
			isPackageDropdownOpen: !this.state.isPackageDropdownOpen
		});
	};

	isPackageChecked = selectedId => this.state.checkedAppIds.includes(selectedId);

	onFilterPackageName = event => {
		const filteredWord = event.target.value;
		this.setState({
			filteredPackageWord: filteredWord
		}, () => {
			this.props.filteringPackages(filteredWord);
			this.checkIsPackageNameExist(filteredWord);
		});
	};

	checkIsPackageNameExist = filteredWord => {
		const packagesNameList = this.props.packages.map(item => item.name);
		const isIn = packagesNameList.includes(filteredWord);
		this.setState({
			isPackageNameExist: isIn
		});
	};

	changeActiveView = view => {
		if (VIEWS[view]) {
			this.setState({
				activeView: VIEWS[view]
			})
		}
	};

	addToPackage = async packageId => {
		await this.props.addAppsToPackage(this.state.checkedAppIds, packageId);
		await this.props.getPackagesList();
		this.setState({
			checkedAppIds: []
		}, () => {
			this.showCurentPackage(packageId)
		});
	};

	removeAppFromPackage = async () => {
		await this.props.removeAppsFromPackage([this.state.selectedAppId], +this.state.activePackage);
		await this.props.getPackagesList();
		this.isOkMoveAppFromPackageModalToggle(null);
		this.showCurentPackage(+this.state.activePackage)
	};

	selectModalHandler = appId => {
		if (this.state.activeView === VIEWS.ALL) {
			this.isOkMoveModalToggle(appId);
		}
		if (this.state.activeView === VIEWS.POCKET) {
			this.isOkMoveAppFromPackageModalToggle(appId);
		}
	};

	selectActiveApk = apkId => {
		return this.props.selectActiveApk(apkId, this.state.activeRetailMarketItemId).then(() => {
			this.fetchPaginatedData(this.state.currentPage)

		})
	};

	changeGlobalView = event => {
		if (this.props.retailApps.length !== 0) {
			this.fetchPaginatedData(this.state.currentPage);
		}
		const value = event.target.value;
		this.setState({
			globalView: value
		});
	};

	getRetailAllApps = page => {
		return this.props.getRetailAppsList({
			companyId: this.props.company.id,
			page,
			filter: this.state.active_filters.join(',')
		})
	};

	getRetailUpdateApps = () => {
		return this.props.getRetailAppsList({
            companyId: this.props.company.id,
			page: 0,
            filter: this.state.active_filters.join(','),
            onlyNeedUpdating: true
		})
	};

	confirmAllHandler = async () => {
		console.log('reload updates', this.state);
        try {
			await this.props.confirmAllUpdates({
				companyId: this.props.company.id ? this.props.company.id : null,
				type: 'ACCEPTED',
				userEmail: this.props.currentUser.email
			});
			await this.props.fetchNewAlertNotifications({
				companyId: this.props.company.id ? this.props.company.id : null,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
			this.setState({
				hasUpdates: false,
			}, () => {console.log(this.state);})
		}
		catch (error) {
			console.log(error)
		}
	};

	/* ----- start upload apk logic ----- */
    toggleUploadModal = () => {
        this.setState({
            uploadModal: !this.state.uploadModal,
            uploadApkName: null,
            uploadApk: null,
			uploadMessage: null,
			uploadComment: null
        });
    };

    closeUploadModal = () => {
        this.setState({
            uploadModal: !this.state.uploadModal,
			isApkUpload: false,
			uploadMessage: null,
			uploadComment: null
        });
    };

    uploadApkClick = () => {
        this.toggleUploadModal();
    };

    onFileSelect = event => {
    	this.setState({
			uploadMessage: null,
			uploadComment: null
		});
        let names = '';
        const uploadedFiles = [];
        if (event.target.files.length) {
            [].forEach.call(event.target.files,f => {
                const data = new FormData();
                data.append('file', f);
                data.append('filename', f.name);
                names = names + ` ${f.name}`;
                uploadedFiles.push(data);
            });

            this.setState({
                uploadApkName: names,
                uploadApk: uploadedFiles,
            })
        }

    };

    sendFile = event => {
        event.preventDefault();
		this.setState({
			uploadMessage: null,
			uploadComment: null
		});
		if (this.state.uploadApk) {
			this.setState({
				isApkUpload: true
			});
			this.props.uploadNewApk(this.state.uploadApk)
				.then( res => {
					console.log('FINAL--', res);
					this.setState({
						uploadApk: null,
						uploadApkName: null,
						isApkUpload: false,
						uploadMessage: res.message,
						uploadComment: res.comment
					});
					this.fetchPaginatedData(this.state.currentPage);
				})
		}
    };
    /* ----- end upload apk logic ----- */

	filterAppByNameHandler = filterWord => {
		this.setState({
			appNameFilterWord: filterWord,
		});
		this.setFilteredDataAndUpdate();
	};

	setFilteredDataAndUpdate = debounce(() => {
		this.setState({
			active_filters: [this.state.appNameFilterWord]
		}, () => {
			this.setCurrentPage(0);
		})
	}, 1000);

	render() {
		const {lang} = this.props;
		return (
			<div>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<UploadModal
					lang={this.props.lang}
					uploadModal={this.state.uploadModal}
					toggleUploadModal={this.toggleUploadModal}
					toggle={this.toggle}
					sendFile={this.sendFile}
					onFileSelect={this.onFileSelect}
					uploadApkName={this.state.uploadApkName}
					isApkUpload={this.state.isApkUpload}
					progressPercent={this.props.progressPercent}
					uploadModal={this.state.uploadModal}
					uploadMessage={this.state.uploadMessage}
					uploadComment={this.state.uploadComment}
					closeUploadModal={this.closeUploadModal}
				/>
				<MoveModal
					lang={this.props.lang}
					moveModal={this.state.isOkMoveModal}
					modalToggle={this.isOkMoveModalToggle}
					removeAppFromRetail={this.removeAppFromRetail}
					moveModalToggle={this.isOkMoveModalToggle}
				/>
				<DelPackageModal
					lang={this.props.lang}
					delPackageModal={this.state.isOkDelPackageModal}
					delPackageModalToggle={this.isOkDelPackageModalToggle}
					removeActivePackage={this.removeActivePackage}
				/>
				<RemoveAppModal
					lang={this.props.lang}
					moveAppFromPackageModal={this.state.isOkMoveAppFromPackageModal}
					moveAppFromPackageModalToggle={this.isOkMoveAppFromPackageModalToggle}
					removeAppFromPackage={this.removeAppFromPackage}
				/>
				<ViewAppModal
					lang={this.props.lang}
					viewAppModal={this.state.isOkViewAppModal}
					viewAppModalToggle={this.isOkViewAppModalToggle}
					activeAppId={this.state.activeAppId}
					activeApkIds={this.state.activeApkIds}
					selectActiveApk={this.selectActiveApk}

				/>
				<ViewAttributesModal
					lang={this.props.lang}
					packageModal={this.state.isOkAttributesPackageModal}
					packageModalToggle={this.isOkAttributesPackageModalToggle}
					isPackageNameExist={this.state.isPackageNameExist}
					onChangePackageName={this.onChangePackageName}
					currentPackageName={this.state.currentPackageName}
					selectedPackage={this.state.selectedPackage}
					updatePocketAttributesList={this.updatePocketAttributesList}
					authority={this.props.authority}
					attrPackageModalToggle={this.attributesPackageModalToggle}
				/>
				<PackageManagerModal
					lang={this.props.lang}
					packageManagerModal={this.state.isOkPackageManagerModal}
					packageManagerToggle={this.isOkPackageManagerToggle}
				/>
				<AddPackageModal
					lang={this.props.lang}
					createPackageModal={this.state.isOkCreatePackageModal}
					createPackageModalToggle={this.isOkCreatePackageModalToggle}
					onChangePackageName={this.onChangePackageName}
					currentPackageName={this.state.currentPackageName}
					cancel={() => {
						this.setState({
							currentPackageName: '',
						});
						this.isOkCreatePackageModalToggle();
					}}
					addPackage={this.addPackage}
					isPackageNameExist={this.state.isPackageNameExist}
					isPackageNameExist={this.state.isPackageNameExist}
				/>
				<Card>
					<CardTitle className="localmarket-title mb-0 p-3 border-bottom bg-light">
						<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].companyMarket}
					</CardTitle>
					<MarketControls
						appNameFilterWord={this.state.appNameFilterWord}
						filterAppByNameHandler={this.filterAppByNameHandler}
						globalView={this.state.globalView}
						changeGlobalView={this.changeGlobalView}
						uploadApk={this.uploadApkClick}
						packageManagerToggle={this.isOkPackageManagerToggle}
						createPackageModalToggle={this.isOkCreatePackageModalToggle}
						confirmAllHandler={this.confirmAllHandler}
						newAlertsTotal={this.props.newAlertsTotal}
						lang={this.props.lang}
						changeLocation={this.props.changeLocation}
					/>
					<Row>
						<Col sm="12" lg="12">
							{
								this.state.globalView === VIEWS.APP_ONLY ||
								this.state.globalView === VIEWS.PACKAGE_ONLY ||
								this.state.globalView === VIEWS.UPDATES_ONLY ? (
									null
								) : (
									<SinglePackage
										packageItem={{
											name: `${I18n[lang].all}`,
											retailMarketItems: this.props.retailApps,
											total: this.props.pagination.totalElements,
										}}
										showApp={this.isOkViewAppModalToggle}
										remove={this.isOkDelPackageModalToggle}
										showAttributes={this.isOkAttributesPackageModalToggle}
										globalView={VIEWS.ALL}
										filter={this.state.active_filters.join(',')}
										id={'all'}
                                        hasUpdates={this.state.hasUpdates}
									/>
								)
							}
							{
								this.state.globalView === VIEWS.APP_ONLY ? (
									<CompanyMarketAppList
										showApp={this.isOkViewAppModalToggle}
										getApps={this.getRetailAllApps}
										filter={this.state.active_filters.join(',')}
										id={'app_only'}
                                        hasUpdates={this.state.hasUpdates}
									/>
								) : this.state.globalView === VIEWS.UPDATES_ONLY ?  (
									<CompanyMarketAppList
										showApp={this.isOkViewAppModalToggle}
										getApps={this.getRetailUpdateApps}
										filter={this.state.active_filters.join(',')}
										id={'updates_only'}
                                        hasUpdates={this.state.hasUpdates}

									/>
								): <PackagesList
										showApp={this.isOkViewAppModalToggle}
										remove={this.isOkDelPackageModalToggle}
										showAttributes={this.isOkAttributesPackageModalToggle}
										globalView={this.state.globalView}
										filter={this.state.active_filters.join(',')}
                                        hasUpdates={this.state.hasUpdates}
									/>
							}
						</Col>
					</Row>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		getRetailAppsList: query => dispatch(getRetailAppsList(query)),
		fetchCompanies: query => dispatch(fetchCompanies(query)),
		moveSingleAppToRetail: appId => dispatch(moveSingleAppToRetail(appId)),
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: url => dispatch(push(url)),
		filteringPackages: filterWord => dispatch(filteringPackages(filterWord)),
		getPackagesList: query => dispatch(fetchPackages(query)),
		saveNewPackage: (packageName, companyId) => dispatch(saveNewPackage(packageName, companyId)),
		addAppsToPackage: (appIds, packageId) => dispatch(addAppsToPackage(appIds, packageId)),
		removePackage: packageId => dispatch(removePackage(packageId)),
		removeAppsFromPackage: (appIds, packageId) => dispatch(removeAppsFromPackage(appIds, packageId)),
		selectActiveApk: (apkId, retailItemId) =>dispatch(updateActiveApk(apkId, retailItemId)),
		getRetailPackageList: (query) => dispatch(getRetailPackageList(query)),
		updatePocketAttributes: attributes => dispatch(updatePocketAttributes(attributes)),
        uploadNewApk: apk => dispatch(uploadNewApk(apk)),
		changePackName: pack => dispatch(changePackName(pack)),
		fetchNewAlertNotifications: (query) => dispatch(fetchNewAlertNotifications(query)),
		confirmAllUpdates: (query) => dispatch(changeUpdatesStatus(query)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	pagination: state.retailAppsList.pagination,
	loading_all: state.retailAppsList.loading,
	retailApps: state.retailAppsList.retailApps,
	company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
	filteredPackages: state.filteredPackages.filteredPackages,
	packages: state.packagesList.packages,
	packageApps: state.retailPackageAppsList.packageApps,
	packagePagination: state.retailPackageAppsList.pagination,
    progressPercent: state.getUploadProgress.progressPercent,
	lang: state.languageReducer.lang,
	newAlertsTotal: state.alertNewNotificationsReducer.totalElements,
	currentUser: state.currentUser
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyMarket)



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/CompanyMarket.js